import {
    useMutation,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import requests from 'app/requests/Order/ContainersBooking.requests'
import {
    ModificationRequiredContainersType,
} from 'app/Apps/OrderManagement/Orders/orders.types'
import {
    OrderModificationReason,
} from 'app/enums/label.enums'
import simpleApi from 'app/services/simpleApi'

type RequestParams = {
    modificationReason: OrderModificationReason,
    orderNumber: string,
    data: Partial<ModificationRequiredContainersType>,
    version: number,
}

const useModifyRequiredContainersCT = (onSuccess) => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessPostpone,
        onError,
    } = useHandleStatusRequest({
        id: 'ModifyRequiredContainers',
        onSuccess,
    })

    return useMutation({
        mutationFn: ({
            modificationReason,
            orderNumber,
            version,
            data,
        }: RequestParams) => {
            return simpleApi({
                ...requests.updateRequiredContainersCustomer({
                    modificationReason,
                    orderNumber,
                    version,
                    data,
                }),
                token,
            })
        },
        onSuccess: onSuccessPostpone,
        onError,
    })
}

export default useModifyRequiredContainersCT
